import styled from "styled-components";
import { device } from "../../helpers/style";

export const ButtonActionGroup = styled.div<{
    margin?: string;
}>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: ${(p) => p.margin || "20px 0 40px 0"};

    & div:first-of-type {
        margin-right: 0;
    }

    & div:last-of-type {
        margin-left: 0;
    }

    @media ${device.phone} {
        flex-direction: column;
        margin: 0 0 30px 0;

        > div {
            margin-bottom: 15px;
        }
    } ;
`;
